import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const loc = useLocation();
  const curPath = loc.pathname;

  const isActive = (path) => curPath.includes(path);

  return (
    <div>
      {/* Desktop Minimal Footer */}
      <footer className="footer ps-3 d-none d-md-flex align-items-center justify-content-between">
        <span style={{ fontSize: "12px", color: "var(--muted)" }}>
          © {new Date().getFullYear()} DenTTrack. All rights reserved.
        </span>
        <div className="d-flex align-items-center gap-3 pe-3">
          <a href="https://denttrack.co.uk" target="_blank" rel="noreferrer" className="text-muted text-decoration-none small">
            Website
          </a>
          <span className="text-muted">•</span>
          <a href="https://denttrack.co.uk/privacy-policy.html" target="_blank" rel="noreferrer" className="text-muted text-decoration-none small">
            Privacy
          </a>
        </div>
      </footer>

      {/* Mobile Footer Branding (Visible at bottom of mobile page content) */}
      <div className="d-md-none text-center py-4 mb-5" style={{ paddingBottom: "75px" }}>
        <div
          className="d-inline-flex flex-column align-items-center justify-content-center px-4 py-2 bg-white rounded-3 shadow-sm border"
          style={{ borderRadius: "10px" }}
        >
          <span style={{ fontSize: "10px", color: "#64748B", textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700, marginBottom: "4px" }}>
            Powered by
          </span>
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt="DenTTrack"
            style={{ maxHeight: "22px", maxWidth: "120px", objectFit: "contain" }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        </div>
      </div>

      {/* Modern Native-like Mobile Bottom Navigation Bar */}
      <nav className="dt-mobile-bottom-nav d-md-none" aria-label="Mobile Navigation">
        <Link
          to={`${process.env.PUBLIC_URL}/dashboard`}
          className={`dt-mob-tab ${isActive("dashboard") ? "is-active" : ""}`}
        >
          <div className="dt-mob-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>
          </div>
          <span>Home</span>
        </Link>

        <Link
          to={`${process.env.PUBLIC_URL}/attendance`}
          className={`dt-mob-tab ${isActive("attendance") || isActive("myrota") || isActive("leave") ? "is-active" : ""}`}
        >
          <div className="dt-mob-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg>
          </div>
          <span>Time Hub</span>
        </Link>

        <Link
          to={`${process.env.PUBLIC_URL}/jobs`}
          className={`dt-mob-tab ${isActive("jobs") ? "is-active" : ""}`}
        >
          <div className="dt-mob-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1Z"/><rect x="4" y="6" width="16" height="15" rx="2"/><path d="M9 12h6M9 16h4"/></svg>
          </div>
          <span>Jobs</span>
        </Link>

        <Link
          to={`${process.env.PUBLIC_URL}/todo`}
          className={`dt-mob-tab ${isActive("todo") ? "is-active" : ""}`}
        >
          <div className="dt-mob-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
          </div>
          <span>Tasks</span>
        </Link>

        <button
          type="button"
          className="dt-mob-tab btn-reset"
          onClick={() => {
            const btn = document.getElementById("dt-mobile-hamburger-btn");
            if (btn) btn.click();
          }}
        >
          <div className="dt-mob-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>
          </div>
          <span>More</span>
        </button>
      </nav>
    </div>
  );
};

export default Footer;
